import React, { useEffect, useState } from "react";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { Text } from "@chakra-ui/react";
import {
  GOOGLE_LIBRARIES,
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_LOADER_ID,
} from "../../lib/googleMaps";

export const GoogleMapItem = ({ info, style }) => {
  const [mapLoaded, setMapLoaded] = useState(false);
  const [center, setCenter] = useState({
    lat: info?.latitude ?? -34.397,
    lng: info?.longitude ?? 150.644,
  });

  // Shared loader — the `id` + `libraries` MUST match every other place we
  // load the Maps script (CreateEventModal, VenueOnboardingModal) so the
  // package can dedupe the <script> tag on the page.
  const { isLoaded } = useJsApiLoader({
    id: GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_LIBRARIES,
  });

  useEffect(() => {
    if (info) {
      setCenter({
        lat: info.latitude ?? -34.397,
        lng: info.longitude ?? 150.644,
      });
    }
  }, [info]);

  const containerStyle = {
    width: "100%",
    height: "200px",
    marginTop: "10px",
    borderRadius: style.borderRadius,
  };

  const mapOptions = {
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
  };

  if (!isLoaded) {
    return <Text>Loading Map...</Text>;
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
      onLoad={() => setMapLoaded(true)}
      onUnmount={() => setMapLoaded(false)}
      options={mapOptions}
    >
      {mapLoaded && <MarkerF position={center} />}
    </GoogleMap>
  );
};
